import React, { useEffect, useState } from 'react';
import { useActivityFeed } from '../../contexts/ActivityFeedContext';
import ActivityCard from './ActivityCard';
import FeedFilters from './FeedFilters';
import CreateActivity from './CreateActivity';
import './ActivityFeed.css';

const ActivityFeed = () => {
  const { feed, loading, error, filterType, setFilterType, fetchFeed } = useActivityFeed();
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    fetchFeed();
  }, [filterType]);

  if (loading && feed.length === 0) {
    return (
      <div className="activity-feed-loading">
        <div className="loading-spinner"></div>
        <p>Loading feed...</p>
      </div>
    );
  }

  if (error && feed.length === 0) {
    return (
      <div className="activity-feed-error">
        <p>Error loading feed: {error}</p>
        <button onClick={() => fetchFeed()}>Retry</button>
      </div>
    );
  }

  return (
    <div className="activity-feed-container">
      <div className="activity-feed-header">
        <h2>Feed</h2>
        <button 
          className="create-activity-btn"
          onClick={() => setShowCreateModal(true)}
        >
          Create Post
        </button>
      </div>

      <FeedFilters 
        filterType={filterType} 
        setFilterType={setFilterType} 
      />

      <div className="activity-feed-list">
        {feed.length === 0 ? (
          <div className="activity-feed-empty">
            <p>No activities in your feed yet.</p>
            <p>Start following companies and users to see their updates!</p>
          </div>
        ) : (
          feed.map((item, index) => (
            <ActivityCard key={`${item.type}-${item.id || index}`} activity={item} />
          ))
        )}
      </div>

      {showCreateModal && (
        <CreateActivity 
          onClose={() => setShowCreateModal(false)}
          onSuccess={() => {
            setShowCreateModal(false);
            fetchFeed();
          }}
        />
      )}
    </div>
  );
};

export default ActivityFeed;

